// extracted by mini-css-extract-plugin
module.exports = {"content":"i_S6","left":"i_S7","right":"i_S8","body":"i_S9","column":"i_TA"};